import styled from "@emotion/styled";

export default styled.div`
  .modal-container {
    background: white;
    border-radius: 12px;
    padding: 0;
    position: relative;
    max-width: 600px;
    margin: 0 auto;
  }

  .modal-header {
    display: flex;
    justify-content: flex-end;
    padding: 20px 20px 0 20px;

    .close-button {
      background: none;
      border: none;
      cursor: pointer;
      padding: 8px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background-color 0.2s ease;

      &:hover {
        background: #f3f4f6;
      }

      img {
        width: 20px;
        height: 20px;
      }
    }
  }

  .modal-content {
    padding: 0 32px 32px 32px;
  }

  .modal-title {
    font-size: 26px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 12px 0;
    text-align: center;
    letter-spacing: -0.025em;
  }

  .modal-subtitle {
    font-size: 16px;
    color: #6b7280;
    text-align: center;
    margin: 0 0 28px 0;
    line-height: 1.5;
    font-weight: 400;
  }

  .athletes-list {
    margin-bottom: 32px;
    border-radius: 12px;
    padding: 16px;
    border: 1px solid #f3f4f6;
    gap: 8px;
  }

  .athlete-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 0;

    &:not(:last-child) {
      border-bottom: 1px solid #e5e7eb;
    }

    .athlete-info {
      display: flex;
      align-items: center;
      gap: 14px;

      .athlete-avatar {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        background: #374151;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-weight: 600;
        font-size: 16px;
        overflow: hidden;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .athlete-name {
        font-size: 16px;
        font-weight: 600;
        color: #111827;
      }
    }

    .attempts-count {
      background-color: #e5e7eb;
      color: #6b7280;
      padding: 6px 12px;
      border-radius: 8px;
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 0.025em;
    }
  }

  .upgrade-plans {
    margin-bottom: 32px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .plan-tabs {
    display: flex;
    background: #f3f4f6;
    border-radius: 9999px;
    padding: 4px;
    gap: 6px;
    width: 100%;
  }

  .tab-button {
    flex: 1;
    padding: 10px 14px;
    border-radius: 9999px;
    border: none;
    background: transparent;
    color: #374151;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;

    &.active {
      background: #ffffff;
      color: #111827;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
    }

    &.disabled,
    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  .plan-card {
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    &.pro-plan {
      background: #ffffff;
      border: 1px solid #e5e7eb;
    }

    &.concierge-plan {
      background: linear-gradient(180deg, #3b7ae3 0%, #2d53d4 100%);
      color: white;
      border: none;
      position: relative;
      overflow: hidden;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.05) 0%,
          rgba(255, 255, 255, 0.02) 100%
        );
        pointer-events: none;
      }
    }

    .plan-title {
      font-size: 18px;
      font-weight: 700;
      margin: 0 0 20px 0;
      color: #111827;
      letter-spacing: -0.025em;

      &.concierge-title {
        color: white;
      }
    }

    .plan-price {
      font-size: 34px;
      font-weight: 800;
      color: #111827;
      margin: 0 0 18px 0;
      letter-spacing: -0.03em;

      .per-month {
        font-size: 16px;
        font-weight: 600;
        color: #6b7280;
        margin-left: 8px;
      }

      .concierge-plan & {
        color: #f9fafb;

        .per-month {
          color: rgba(255, 255, 255, 0.85);
        }
      }
    }

    .plan-features {
      display: flex;
      flex-direction: column;
      gap: 16px;

      .feature-item {
        display: flex;
        align-items: flex-start;
        gap: 12px;

        .feature-number {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          background: #3b82f6;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: 700;
          flex-shrink: 0;
          margin-top: 2px;
          box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);
          position: relative;

          &::after {
            content: "";
            position: absolute;
            width: 8px;
            height: 8px;
            background: #3b82f6;
            border-radius: 50%;
            bottom: 0px;
            right: -2px;
            border-radius: 50%;
          }
        }

        .feature-checkmark {
          width: 24px;
          height: 24px;
          background: white;
          border-radius: 50%;
          color: #3b82f6 !important;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: 700;
          flex-shrink: 0;
          color: white;
          margin-top: 2px;
          backdrop-filter: blur(10px);
          position: relative;

          &::after {
            content: "";
            position: absolute;
            width: 8px;
            height: 8px;
            background: white;
            border-radius: 50%;
            bottom: 0px;
            right: -2px;
          }
        }

        .concierge-plan-feature-text {
          font-size: 15px;
          line-height: 1.5;
          color: #fff;
          font-weight: 500;
          margin-top: 2px;
        }

        .feature-text {
          font-size: 15px;
          line-height: 1.5;
          color: #374151;
          font-weight: 500;
          margin-top: 2px;

          .concierge-plan & {
            color: rgba(255, 255, 255, 0.95);
            font-weight: 400;
          }
        }
      }
    }
  }

  .upgrade-button-container {
    display: flex;
    justify-content: center;
    margin-top: 8px;
    width: 100%;

    .upgrade-button {
      width: 100%;
    }
  }

  /* Responsive */
  @media (max-width: 640px) {
    .modal-container {
      margin: 16px;
      max-width: calc(100vw - 32px);
    }

    .modal-content {
      padding: 0 20px 24px 20px;
    }

    .modal-title {
      font-size: 22px;
    }

    .modal-subtitle {
      font-size: 15px;
    }

    .athletes-list {
      padding: 12px;
    }

    .plan-card {
      padding: 20px;

      .plan-title {
        font-size: 16px;
        margin-bottom: 16px;
      }

      .plan-features {
        gap: 14px;

        .feature-item {
          .feature-number {
            width: 24px;
            height: 24px;
            font-size: 12px;
          }

          .feature-checkmark {
            width: 20px;
            height: 20px;
            font-size: 12px;
          }

          .feature-text {
            font-size: 14px;
          }
        }
      }
    }

    .athlete-item {
      padding: 12px 0;

      .athlete-info {
        gap: 12px;

        .athlete-avatar {
          width: 40px;
          height: 40px;
          font-size: 14px;
        }

        .athlete-name {
          font-size: 15px;
        }
      }

      .attempts-count {
        font-size: 12px;
        padding: 5px 10px;
      }
    }
  }
`;
